import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'

import CompetitorReferenceForm from './CompetitorReferenceForm'
import { storeCompetitorReference } from '../services'
import { handleError } from '../../../helpers'

export default function NewCompetitorReferenceForm({ reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm();

	const onSubmit = values => {
		storeCompetitorReference(values)
			.then(() => {
				message.success('Referencia creada exitosamente.')
				reload()
				reset()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<CompetitorReferenceForm register={register} errors={errors} />
				<Button type="submit" color="primary">Crear Referencia</Button>
			</Form>
		</React.Fragment>
	)
}